import { ACTION, DEFAULT_TEXTURE_SETTINGS, MATERIAL } from '../constants'
import { threeDStudioStore } from '../index'

const setTextureSettingsState = (patch) => {
  threeDStudioStore.setState((state) => ({
    textureSettings: { ...state.textureSettings, ...patch },
  }))
}

/**
 * Resets all texture settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    textureSettings: { ...DEFAULT_TEXTURE_SETTINGS },
  })
}

/**
 * Sets the input image (asset ID) and its URL.
 * Also switches the enhanced action to `retexture` and clears run/session.
 * @param {number|undefined} id - Input image asset id
 * @param {string|undefined} url - Input image URL (e.g. blob URL or file URL)
 */
export const setInputImage = (id, url) => {
  if (id === undefined) {
    threeDStudioStore.setState((state) => ({
      textureSettings: {
        ...state.textureSettings,
        inputImage: undefined,
        inputImageUrl: undefined,
      },
    }))

    return
  }

  threeDStudioStore.setState((state) => ({
    textureSettings: {
      ...state.textureSettings,
      inputImage: id,
      inputImageUrl: url,
    },
    schema: {
      ...state.schema,
      enhancedAction: ACTION.RETEXTURE,
    },
  }))
}

/**
 * Sets the prompt.
 * @param {string} prompt - User prompt for generation
 */
export const setPrompt = (prompt) => {
  setTextureSettingsState({ prompt })
}

/**
 * Sets the texture resolution/quality.
 * @param {string} textureQuality - One of: "2k", "4k", "8k"
 */
export const setTextureQuality = (textureQuality) => {
  setTextureSettingsState({ textureQuality })
}

/**
 * Sets the material type
 * @param {string} material - One of: "pbr", "basic", "all"
 */
export const setMaterial = (material) => {
  if (material === MATERIAL.PBR) {
    setTextureSettingsState({ enablePbr: true, material })
    return
  }

  if (material === MATERIAL.BASIC) {
    setTextureSettingsState({ enablePbr: false, material })
    return
  }

  if (material === MATERIAL.GEOMETRY_ONLY) {
    setTextureSettingsState({ enablePbr: false, material })
  }
}
